/**
 * Module 6's "Resource Type — Enum (display filter)".
 *
 * <p>It filters what has already been fetched rather than asking the server again: a
 * chapter is a handful of rows, all of them already in hand, and a round trip per chip
 * would make the filter feel slower than scrolling past what it hides.
 *
 * <p>Only types actually present in the chapter get a chip, so a student is never
 * offered a filter that would empty the list.
 */
export default function ResourceTypeFilter({ resources, selected, onChange }) {
  const counts = new Map();
  for (const resource of resources ?? []) {
    counts.set(resource.type, {
      label: resource.typeLabel,
      count: (counts.get(resource.type)?.count ?? 0) + 1,
    });
  }
  // One kind of thing in the chapter means there is nothing to filter between.
  if (counts.size < 2) return null;

  return (
    <div className="filter-chips" role="group" aria-label="Filter by type">
      <button
        type="button"
        className="chip"
        aria-pressed={selected === null}
        onClick={() => onChange(null)}
      >
        All ({resources.length})
      </button>
      {[...counts.entries()].map(([type, { label, count }]) => (
        <button
          type="button"
          key={type}
          className="chip"
          aria-pressed={selected === type}
          onClick={() => onChange(selected === type ? null : type)}
        >
          {label} ({count})
        </button>
      ))}
    </div>
  );
}

/** The filter itself, kept beside the control so both sides use one rule. */
export function applyTypeFilter(resources, selected) {
  if (!resources) return resources;
  if (!selected) return resources;
  return resources.filter((resource) => resource.type === selected);
}
